module.exports = __webpack_public_path__ + "img/tab1.10c49bb3.png";